import { Typography } from "@mui/material";

const HeaderText = ({ type, text, fWeight }) => {
  return (
    <>
      <Typography
        variant={type}
        gutterBottom
        style={{ fontWeight: fWeight, color: "#252524" }}
      >
        {text}
      </Typography>
    </>
  );
};

export default HeaderText;
